module.exports = __webpack_public_path__ + "static/media/logo_traktorpool.69ce461b.svg";